import React from 'react';
import { Link } from 'react-router-dom';
import { isDemo } from '../App';

// Tab bar shared by the three benchmark pages, which sit under one
// "Benchmarks" item in the sidebar.
const TABS = [
  { key: 'games', label: 'Games & Benchmark Mode', path: '/benchmark-mode' },
  { key: 'process', label: 'Process Benchmarks', path: '/benchmarks' },
  { key: 'hph', label: 'HPH / RPH Benchmarks', path: '/hph-benchmarks' },
];

const base = {
  padding: '10px 18px',
  borderRadius: '8px 8px 0 0',
  fontSize: '14px',
  fontWeight: 'bold',
  textDecoration: 'none',
  borderBottom: '3px solid transparent',
  whiteSpace: 'nowrap',
};

const styles = {
  bar: {
    display: 'flex',
    gap: '4px',
    flexWrap: 'wrap',
    borderBottom: '1px solid #0f3460',
    marginBottom: '28px',
  },
  tab: { ...base, color: '#a0a0b0' },
  tabActive: { ...base, color: '#ffffff', backgroundColor: '#16213e', borderBottom: '3px solid #e94560' },
};

export default function BenchmarkTabs({ current }) {
  return (
    <div style={styles.bar}>
      {TABS.filter(t => !isDemo() || t.key !== 'games').map(t => (
        <Link key={t.key} to={t.path} style={t.key === current ? styles.tabActive : styles.tab}>
          {t.label}
        </Link>
      ))}
    </div>
  );
}
